import CheckPermission from '../../../hooks/CheckPermission';
import React from 'react'
import { Form, Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import { FaCheckDouble, FaPlusCircle, FaTimes } from 'react-icons/fa'
import moment from 'moment'
import * as Yup from 'yup'

import ReusableModal from '../../../shared/ReuseableModal'
import TextInput from '../../../shared/TextInput'
import CustomButton from '../../../shared/CustomButton'
import DatePicker from '../../../shared/DatePicker'

const AddReferralModal = ({

  isVisible,
  onClose,
  onSubmit,
  initialValues = { auth_ref: '', valid_until: '' }
}) => {
  const { t } = useTranslation()
  const { hasPermission } = CheckPermission();

  const validationSchema = Yup.object({
    auth_ref: Yup.string()
      .trim()
      .required(t('Authorization reference is required')),
    valid_until: Yup.date()
      .min(moment().startOf('day').toDate(), t('Valid until cannot be in the past'))
      .required(t('Valid until is required'))
  })

  const formInitialValues = {
    ...initialValues,
    valid_until: initialValues.valid_until
      ? moment(initialValues.valid_until, 'YYYY-MM-DD').toDate()
      : null
  }

  const handleSubmit = values => {
    if (!hasPermission('visit', 'create') && !hasPermission('visit', 'update')) return;
    onSubmit({
      ...values,
      valid_until: moment(values.valid_until).format('YYYY-MM-DD')
    })
  }

  return (
    <ReusableModal
      isVisible={isVisible}
      title={t('Add Referral')}
      HeaderIcon={FaPlusCircle}
      className='w-full md:w-[600px]'
      onClose={onClose}
      position='top'
    >
      <Formik
        initialValues={formInitialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
              <TextInput
                name='auth_ref'
                placeholder={t('Enter authorization reference')}
                label={t('Authorization Reference')}
              />
              <DatePicker
                name='valid_until'
                label={t('Valid Until')}
                dateFormat='dd/mm/yy'
                minDate={moment().startOf('day').toDate()}
                placeholder={t('Select a date')}
                showIcon
              />
            </div>

            <div className='flex justify-end gap-2 mt-4'>
              <CustomButton
                label={t('Cancel')}
                buttonType='reset'
                onClick={onClose}
              />
              {(hasPermission('visit', 'create') || hasPermission('visit', 'update')) && (
                <CustomButton
                  type='submit'
                  label={t('Add Referral')}
                  icon={<FaCheckDouble size={12} />}
                  loading={isSubmitting}
                />
              )}
            </div>
          </Form>
        )}
      </Formik>
    </ReusableModal>
  )
}

export default AddReferralModal
